export default "__VITE_ASSET__2Wx8nXgZ__"